import { render, staticRenderFns } from "./AdminAddcomment.vue?vue&type=template&id=eb56c32c&scoped=true&"
import script from "./AdminAddcomment.vue?vue&type=script&lang=js&"
export * from "./AdminAddcomment.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddcomment.vue?vue&type=style&index=0&id=eb56c32c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb56c32c",
  null
  
)

export default component.exports